import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./Messages";
import employerDetailsApi from "../../services/employerDetailsApi";
import authService from "../../services/authService";

export const getEmpCountryCode = createAsyncThunk(
  "empDetails/getEmpCountryCode",
  async (thunkAPI) => {
    try {
      const data = await employerDetailsApi.getEmpCountryCode();
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const getLanguage = createAsyncThunk(
  "empDetails/getLanguage",
  async (thunkAPI) => {
    try {
      const data = await employerDetailsApi.getLanguage();
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const getNationality = createAsyncThunk(
  "empDetails/getNationality",
  async (thunkAPI) => {
    try {
      const data = await employerDetailsApi.getNationality();
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const getEmployerDetails = createAsyncThunk(
  "empDetails/getEmployerDetails",
  async (emp, thunkAPI) => {
    try {
      const data = await employerDetailsApi.getEmpDetails(emp);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  countryCodes: [],
  empLanguages: [],
  nationalities: [],
  employerDetails: {},
};
const empDetailsSlice = createSlice({
  name: "empDetails",
  initialState,
  reducers: {
    getEmployer: (state, action) => {
      state.employerDetails = action.payload;
    },
    clearEmployerDetails: (state) => {
      state.employerDetails = {};
    },
  },
  extraReducers: {
    [getEmpCountryCode.fulfilled]: (state, action) => {
      state.countryCodes = action.payload.response.data;
    },
    [getLanguage.fulfilled]: (state, action) => {
      state.empLanguages = action.payload.response.data;
    },
    [getNationality.fulfilled]: (state, action) => {
      state.nationalities = action.payload.response.data;
    },
    [getEmployerDetails.fulfilled]: (state, action) => {
      state.employerDetails = action.payload.response.data;
    },
    [getEmployerDetails.rejected]: (state) => {
      state.employerDetails = {};
    },
  },
});

const { reducer } = empDetailsSlice;
export const { getEmployer, clearEmployerDetails } = empDetailsSlice.actions;
export default reducer;
